<template>
    <div 
        v-if="!!trustScore" 
        :class="{' bg-light': !!trustScore}" 
        class="d-flex justify-content-center align-items-center gap-1 rounded-pill fs-6 px-1 py-1"
    >
        <img class="mb-1" src="@/assets/svg/brands/trustpilot.svg">
        <span class="fw-bold pe-1">{{ trustScore }}</span>
        <span class="pe-1">
            {{ 
                `(${$translate('reviews_count', '{count} omdömen')
                    .replace('{count}', trustScoreCount)})`
            }}
        </span>
        <Tooltip
            :text="$translate('trustpilot_tooltip', 'På Trustpilot')"
            icon-class="ms-1"
        />
    </div>
    <span v-else-if="!disableEmptySpacing" :class="{ 'd-none': !trustScore}" class="d-md-flex mb-2 py-1 fs-6">
        &nbsp; <!-- this maintains alignment across image and table rows -->
    </span>
</template>

<script>
import Tooltip from '@/components/features/Tooltip.vue';
export default {
    components: {
        Tooltip
    },
    props: {
        trustScore: {
            type: Number,
            required: true,
            default: 0
        },
        trustScoreCount: {
            type: Number,
            required: true,
            default: 0
        },
        disableEmptySpacing: {
            type: Boolean,
            default: false
        }
    }
};
</script>